export const onChangeProjectName = (state, payload) => {
    return {
        ...state,
        localStateData: {
            ...state.localStateData,
            projectName: payload.projectName
        }
    }
}